import GeoJSON from 'ol/format/GeoJSON';
import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {getUpdatedFilters} from '@src/selectors/filters.js';
import {getSelectedItemTypes} from '@src/selectors/item-types';
import {getMapFeatureGeometry} from '@src/selectors/map';
import {computeGeometryTooLarge} from '@src/utils/geom.js';
import {getSearchFilters} from '@src/utils/searchFilters.js';

const formatGeoJSON = new GeoJSON();

const useSearchFilters = ({useNoEndDate} = {}) => {
  const dateRanges = useSelector(state => state.search.dateRanges);
  const filters = useSelector(state => state.searchFilters);
  const geometry = useSelector(getMapFeatureGeometry);
  const noEndDate = useSelector(state => state.search.noEndDate);
  const selectedItemTypes = useSelector(getSelectedItemTypes);
  const singleItemSearchId = useSelector(
    state => state.search.singleItemSearchId,
  );
  const updatedFilters = useSelector(getUpdatedFilters);

  const {geometryTooLarge} = geometry
    ? computeGeometryTooLarge(formatGeoJSON.readGeometry(geometry))
    : false;

  return useMemo(
    () => ({
      searchFilters: getSearchFilters({
        dateRanges,
        geometryTooLarge,
        noEndDate,
        searchFilters: filters,
        selectedItemTypes,
        singleItemSearchId,
        updatedFilters,
        useNoEndDate,
      }),
    }),
    [
      dateRanges,
      geometryTooLarge,
      noEndDate,
      filters,
      selectedItemTypes,
      singleItemSearchId,
      updatedFilters,
      useNoEndDate,
    ],
  );
};

export default useSearchFilters;
